module.exports = __webpack_public_path__ + "media/logos/usluga_rekomendowana_DW_2019-b6405e54.svg";